export default __webpack_public_path__ + "static/media/react.e5f031c5.svg";